export const messages = {
  en: {
    supplierManage: {
      searchCondition: 'Search Condition',
      moreCondition: 'More',
      hide: 'Hide',
      supplierInfo: 'Supplier Information',
      add: 'Add',
      supplierType: 'Supplier Type',
      supplierName: 'Supplier Name',
      contactPerson: 'Contact Person',
      contactTel: 'Contact Number',
      startTime: 'Start Time',
      endTime: 'End Time',
      createTime: 'Create Time',
      remark: 'Remark',
      operation: 'Operation',
      edit: 'Edit',
      config: 'Configure',
      delete: 'Delete',
      query: 'Search',
      confirmDelete: 'Confirm Delete',
      deleteTip: 'Are you sure to delete this supplier?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      pleaseSelect: 'Please select',
      requiredField: 'Required field',
      template:'Template'
    }
  },
  zh: {
    supplierManage: {
      searchCondition: '查询条件',
      moreCondition: '更多',
      hide: '隐藏',
      supplierInfo: '供应商信息',
      add: '添加',
      supplierType: '供应商类型',
      supplierName: '供应商名称',
      contactPerson: '联系人',
      contactTel: '联系电话',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '创建时间',
      remark: '备注',
      operation: '操作',
      edit: '修改',
      config: '配置',
      delete: '删除',
      query: '查询',
      confirmDelete: '确认删除',
      deleteTip: '确定删除供应商吗？',
      cancel: '取消',
      confirm: '确认',
      pleaseSelect: '请选择',
      requiredField: '必填项',
      template:'模版'
    }
  },
  'zh-TW': {
    supplierManage: {
      searchCondition: '查詢條件',
      moreCondition: '更多',
      hide: '隱藏',
      supplierInfo: '供應商信息',
      add: '添加',
      supplierType: '供應商類型',
      supplierName: '供應商名稱',
      contactPerson: '聯繫人',
      contactTel: '聯繫電話',
      startTime: '開始時間',
      endTime: '結束時間',
      createTime: '創建時間',
      remark: '備註',
      operation: '操作',
      edit: '修改',
      config: '配置',
      delete: '刪除',
      query: '查詢',
      confirmDelete: '確認刪除',
      deleteTip: '確定刪除供應商嗎？',
      cancel: '取消',
      confirm: '確認',
      pleaseSelect: '請選擇',
      requiredField: '必填項',
      template:'模板'
    }
  }
}